import type { PlacementId } from './api/index.js';

declare global {
  namespace JSX {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface IntrinsicElements {
      /** @see https://github.schibsted.io/nmp-web/content-management-podlet */
      'advt-sponsored-content-teaser': {
        id: string;
        metaData?: {
          vertical: string;
          subvertical: string;
          pageType: string;
        };
        sponsoredContent?: object;
      };

      /** @see https://github.schibsted.io/nmp-web/content-management-podlet/blob/main/src/client/contentfulBlocks/containers/sponsored-content-cmp-wrapper.ts */
      'sponsored-content-cmp-wrapper': {
        /** @see https://github.schibsted.io/nmp-web/content-management-podlet/blob/main/src/types/types-cmp.ts */
        cmpContent: string;
        children?: unknown;
      };

      'advt-component': {
        placementId: PlacementId;
        adIndex?: number | undefined;
        categories?: object | undefined;
        key?: string;
        initialLayoutType?: string | undefined;
        initialAspectFormat?: string | undefined;
        children?: unknown;
      };

      'contentful-sov-fetcher': {
        adPosition: PlacementId;
      };
    }
  }

  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    pulse: unknown;
    gtag(...args: Array<unknown>): void;
    dataLayer: Record<string, unknown>;
    adServer: Record<string, unknown>;
    apntag?: Record<string, unknown> & { requests: Record<string, unknown> };

    _tcf_?: {
      getConsentedToAllSync(): boolean;
      isConsentedToAll(callback: (value: boolean) => void): void;
    };

    /** Atom for creative to set static/sticky position on skyscrapers banners. */
    skyscrapersAtom: {
      get: () => 'sticky' | 'static';
      set: (value: 'sticky' | 'static') => void;
    };
  }
}

export {};
